import Button from "@mui/material/Button";
import {
    Box,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    FormControlLabel,
    Grid,
    Radio
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import {Modal} from "react-bootstrap";
import {Viewer, Worker} from "@react-pdf-viewer/core";
import React, {useState} from "react";
import t from "../../../Utils/Translation";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";

const CandidateChoice = (props) => {

    const jobAnnouncementUrl = localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/Annuncio+IRC217703+VALUTAZIONE.pdf": "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Job+announcement_JuniorR%26DFermentation+(VALUTAZIONE)+ENG.pdf"
    const [modal, setModal] = useState(null);

    const handleOpen = (id) => {
        setModal(id);
    };
    const handleClose = () => {
        setModal(null);
    };
    const rootStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };
    const gridStyles = {
        width: '80%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    const cardStyles = {
        width: '80%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const [selectedValue, setSelectedValue] = useState('candidate1');

    const handleChange = (event) => {
        setSelectedValue(event.target.value);

        props.setCandidatesResults(prevState => {
            const updatedCandidates = {...prevState};
            updatedCandidates['candidateChoice'] = event.target.value;
            return updatedCandidates;
        })
    };

    const handleChangeOnCardClick = (val) => {
        setSelectedValue(val)
        props.setCandidatesResults(prevState => {
            const updatedCandidates = {...prevState};
            updatedCandidates['candidateChoice'] = val;
            return updatedCandidates;
        })
    }
    const handleNextStep = () => {
        if(selectedValue === 'candidate1') {
            console.log('eee')
            props.setCandidatesResults(prevState => {
                const updatedCandidates = {...prevState};
                updatedCandidates['candidateChoice'] = 'candidate1';
                return updatedCandidates;
            })
        }
        props.handleNextStep();


    }

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });


    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance


    return (
        <>
            <Grid container direction="column">
                <Grid item>
                    <Box>
                        <Button className={' p-2 mx-4'} onClick={() => handleOpen(4)} style={{float: 'right', background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '10px', fontSize: '24px' }}>{t("Job announcement")}</Button>
                    </Box>
                </Grid>
                <Grid item>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <h4 style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)",  borderRadius:'10px', padding:'20px'}}>{t("WHICH CANDIDATE ARE YOU CHOOSING?")}</h4>
                    </div>
                </Grid>
            </Grid>

            <Grid container spacing={10} style={rootStyles}>
                <Grid item xs={3} style={gridStyles}>
                    <Card style={cardStyles}>
                        <CardActionArea onClick={() => handleChangeOnCardClick('candidate1')}>
                            <CardHeader  title={'Silvia'} style={{ background: "linear-gradient(to bottom, #006f4b, #006f4b)", maxWidth: '60%' }}/>
                            <CardMedia
                                component="img"
                                alt="Card 1"
                                height="100%"
                                image="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/SILVIA.jpeg"
                                title="Card 1"
                            />
                            <CardContent>
                                <Box textAlign={'center'}>
                                    <FormControlLabel
                                        value="candidate1"
                                        control={<Radio color="success" />}
                                        label=""
                                        checked={selectedValue === 'candidate1'}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={3} style={gridStyles}>
                    <Card style={cardStyles}>
                        <CardActionArea onClick={() => handleChangeOnCardClick('candidate2')}>
                            <CardHeader  title={'Bilal'} style={{ background: "linear-gradient(to bottom, #006f4b, #006f4b)", maxWidth: '60%', borderTopRightRadius: '15px' }}/>
                            <CardMedia
                                component="img"
                                alt="Card 2"
                                height="100%"
                                image="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/BILAL.png"
                                title="Card 2"
                            />
                            <CardContent>
                                <Box textAlign={'center'}>
                                    <FormControlLabel
                                        value="candidate2"
                                        control={<Radio color="success" />}
                                        label=""
                                        checked={selectedValue === 'candidate2'}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </CardContent>
                        </CardActionArea>

                    </Card>
                </Grid>
                <Grid item xs={3} style={gridStyles}>
                    <Card style={cardStyles}>
                        <CardActionArea onClick={() => handleChangeOnCardClick('candidate3')}>
                            <CardHeader  title={'Giulia'} style={{  background: "linear-gradient(to bottom, #006f4b, #006f4b)", maxWidth: '60%', borderTopRightRadius: '15px' }}/>
                            <CardMedia
                                component="img"
                                alt="Card 3"
                                height="100%"
                                image="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/GIULIA_.png"
                                title="Card 3"
                            />
                            <CardContent>
                                <Box textAlign={'center'}>
                                    <FormControlLabel
                                        value="candidate3"
                                        control={<Radio color="success" />}
                                        label= ""
                                        checked={selectedValue === 'candidate3'}
                                        onChange={handleChange}
                                    />
                                </Box>

                            </CardContent>
                        </CardActionArea>

                    </Card>
                </Grid>
            </Grid>
            <Box className={'mt-5'} display="flex" justifyContent="center" m={1}>
                <Button variant="contained" color="primary" onClick={handleNextStep} style={{ margin: '8px',background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '10px', fontSize: '24px' }}>
                    {t("PROCEED")}
                </Button>
            </Box>

            {modal === 4 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{t("Job announcement")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={jobAnnouncementUrl} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

        </>
    )
};

export default CandidateChoice;